import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      dashboard: {
        featured: {
          featured: 'Featured',
          newsAndEvent: 'FIINGROUP NEWS & EVENTS',
        },
        latestReport: {
          latestReport: 'Latest Reports by FiinGroup',
          viewAll: 'View all',
          backDashboard: 'Back to Dashboard',
          category: 'Category',
          publicDate: 'Publication Date',
          reportName: 'Report name',
          placeHolderSearch: "Enter report's name",
          allReports: 'All Reports',
        },
        recentlyAndPopular: {
          titlePopular: 'Most popular on FiinGate',
          titleRecently: 'Recently viewed by you',
          noView: 'You have no recent viewed item',
        },
        creditRisk: {
          title: 'Risk Distribution: Corporate Risk',
          companies: '%{count} Companies',
          company: '%{count} Company',
          industry: 'Industry',
          numberOfCompanies: 'Number of companies',
          text_legend:
            'Number of companies with sufficient data to calculate corporate risk score.',
        },
        interested: {
          title: 'You may be also interested in',
          portfolio: 'Portfolio',
          companies: 'Companies',
          description: 'Description',
          companyList: 'Company List',
          textNoData:
            'The recommended company list considers both current trends and your preferred sectors. If you want to customize your preferences, you can specify your field of interest in',
          linkSetting: 'Preferences & Settings',
          goToPreferenceSettings:
            'Customize your list of interested companies by industry in Industry Interests under Settings & Preferences.',
          lastUpdatedDate: 'Last updated date: %{date}',
        },
        suggestDetail: {
          title: 'Recommended by FiinGate Analytical Team',
          cancel: 'Cancel',
          addToPortfolio: 'Add to Portfolio',
          companyName: 'Company Name',
          selectedCompanies: 'Selected Companies (%{count})',
        },
        yourPortfolio: {
          title: 'Your Portfolios',
          creditScore: 'Corporate Risk Score',
          performanceScore: 'Performance Score',
          canUpgrade:
            'Your current plan does not allow to use this feature. Please upgrade to Premium to have best experience',
          createPort: 'Start creating your portfolio',
        },
        totalAlert: {
          title: 'Total Alerts',
          totalAlert: 'Total Alerts',
          viewAllAlert: 'View all Alerts',
          unreadAlerts: 'Unread Alerts',
          viewUnreadAlerts: 'View unread alerts',
          negativeAlerts: 'Negative Alerts',
          viewNegativeAlerts: 'View negative alerts',
          totalAlertCompany: 'Company',
          totalAlertIndustry: 'Industry',
          totalAlertMacroeconomic: 'Macroeconomic',
          noData: 'You have no alert',
        },
        currentPlan: {
          title: 'Current Plan',
          expiryDays: '%{count} days left till expiration',
          expiryDay: '%{count} day left till expiration',
          upgrade: 'Upgrade to Premium',
          package: 'Package',
          purchaseMore: 'Purchase more',
          remaining: 'Remaining',
          day: '%{count} day',
          days: '%{count} days',
          noLimit: 'Unlimited days left till expiration',
          seeCompany: 'See Trial List',
          trialList: 'Trial List',
          noPackage: 'You have no package',
          getConnectMap: 'Get ConnectMap',
          connectMap: 'ConnectMap',
          connectMapExpiryDay: 'Expired on %{date}',
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      dashboard: {
        featured: {
          featured: 'Tin nổi bật',
          newsAndEvent: 'Tin tức & Sự kiện',
        },
        latestReport: {
          latestReport: 'Báo cáo mới nhất từ FiinGroup',
          viewAll: 'Xem tất cả',
          backDashboard: 'Quay về Dashboard',
          category: 'Loại',
          publicDate: 'Ngày phát hành',
          reportName: 'Tên báo cáo',
          placeHolderSearch: 'Nhập tên báo cáo',
          allReports: 'Mọi Báo cáo',
        },
        recentlyAndPopular: {
          titlePopular: 'Phổ biến trên FiinGate',
          titleRecently: 'Được xem gần đây',
          noView: 'Bạn không có công ty vừa xem',
        },
        creditRisk: {
          title: 'Phổ điểm: Rủi ro doanh nghiệp',
          companies: '%{count} Công ty',
          company: '%{count} Công ty',
          industry: 'Ngành',
          numberOfCompanies: 'Số lượng công ty',
          text_legend:
            'Số lượng công ty có đủ dữ liệu để tính điểm rủi ro doanh nghiệp.',
        },
        interested: {
          title: 'Đề xuất bởi Đội ngũ phân tích FiinGate',
          portfolio: 'Danh mục',
          companies: 'Công ty',
          description: 'Mô tả',
          companyList: 'Danh sách công ty',
          textNoData:
            'Danh sách công ty được đề xuất dựa trên xu hướng hiện tại và lĩnh vực bạn quan tâm. Nếu muốn điều chỉnh các tùy chọn của mình, bạn có thể thay đổi trong',
          linkSetting: 'Tùy chọn & Cài đặt',
          goToPreferenceSettings:
            'Tùy chỉnh danh sách công ty bạn quan tâm theo từng ngành tại mục Các ngành quan tâm trong trang Cài đặt & Tùy chọn.',
          lastUpdatedDate: 'Ngày cập nhật cuối: %{date}',
        },
        suggestDetail: {
          title: 'Khuyến nghị từ đội phân tích FiinGate',
          cancel: 'Hủy',
          addToPortfolio: 'Thêm vào danh mục',
          companyName: 'Tên công ty',
          selectedCompanies: 'Công ty đã được chọn (%{count})',
        },
        yourPortfolio: {
          title: 'Danh mục của bạn',
          creditScore: 'Điểm Rủi Ro Doanh Nghiệp',
          performanceScore: 'Điểm Tiềm Năng Tăng Trưởng',
          canUpgrade:
            'Gói hiện tại của bạn không cho phép sử dụng tính năng này. Vui lòng nâng cấp lên Premium để có trải nghiệm tốt nhất',
          createPort: 'Bắt đầu tạo danh mục đầu tư của bạn',
        },
        totalAlert: {
          title: 'Tổng Số Cảnh Báo',
          totalAlert: 'Tổng số',
          viewAllAlert: 'Xem toàn bộ Cảnh báo',
          unreadAlerts: 'Chưa đọc',
          viewUnreadAlerts: 'Xem cảnh báo chưa đọc',
          negativeAlerts: 'Tiêu cực',
          viewNegativeAlerts: 'Xem cảnh báo tiêu cực',
          totalAlertCompany: 'Công ty',
          totalAlertIndustry: 'Ngành',
          totalAlertMacroeconomic: 'Kinh tế vĩ mô',
          noData: 'Bạn không có cảnh báo',
        },
        currentPlan: {
          title: 'Tài khoản hiện tại',
          expiryDays: '%{count} ngày trước khi hết hạn',
          expiryDay: '%{count} ngày trước khi hết hạn',
          upgrade: 'Nâng cấp lên Premium',
          package: 'Gói báo cáo',
          purchaseMore: 'Mua thêm',
          remaining: 'Còn lại',
          day: '%{count} ngày',
          days: '%{count} ngày',
          noLimit: 'Không giới hạn ngày còn lại cho đến khi hết hạn',
          seeCompany: 'Xem Danh sách Trial',
          trialList: 'Danh sách Trial',
          noPackage: 'Bạn không có gói',
          getConnectMap: 'Kích hoạt Bản đồ kết nối',
          connectMap: 'Bản đồ kết nối',
          connectMapExpiryDay: 'Hết hạn vào %{date}',
        },
      },
    },
  }),
)
